<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  watch: {},
  created() {},
  methods: {
    reload() {
      // 用于路由跳转时刷新页面
      this.isRouterAlive = false;
      this.$nextTick(function(){
			this.isRouterAlive = true;
      });
    }
  },
  computed: {}
};
</script>
<style lang="scss">
#app{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
